import React from 'react';
var Menu = require('../ui_elements/menu').Menu;
var MenuList = require('../ui_elements/menu-list');

import {VstInput, VstButton} from 'vstui';
import Dispatcher from '../../dispatcher';

// Renders the User Sign In
class SigninContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: this.props.email ? decodeURIComponent(this.props.email) : '',
      password: "",
      error: null,
      captcha: this.props.captcha
    };

    // Bind callback methods
    this._checkSigninSubmit = this._checkSigninSubmit.bind(this);
    this._throwSigninError = this._throwSigninError.bind(this);
    this._clickResetPassword = this._clickResetPassword.bind(this);
    this._cleverLogin = this._cleverLogin.bind(this);
    this._onEmailChange = this._onEmailChange.bind(this);
    this._onPasswordChange = this._onPasswordChange.bind(this);
    this._localeChanged = this._localeChanged.bind(this);
    this._recaptchaRendered = this._recaptchaRendered.bind(this);
    this._startRecaptcha = this._startRecaptcha.bind(this);
    this.loadRecaptchaScript = this.loadRecaptchaScript.bind(this);
    this.getError = this.getError.bind(this);

    this.loginFailureRef = React.createRef();
    this.loginErrorRef = React.createRef();
  }

  componentDidMount(){
    // merged from componentWillMount
    if (Fraction.User && Fraction.User.email) {
      Fraction.Helpers.clearRedirect();
      Fraction.Router.setRoute("/");
    } else {
      Fraction.Router.setRoute("user/signin", true);
    }

    // original componentDidMount content
    if (this.props.status==="failure"){
      this._throwSigninError();
    }

    $(".account-graphic").find("img").on("load", this.props.redraw);

    // load recaptcha only if necessary
    if (this.props.captcha){
      this.loadRecaptchaScript();
    }

    Dispatcher.bind(Dispatcher.LOCALE_CHANGE, this._localeChanged);
    Dispatcher.bind(Dispatcher.RECAPTCHA_RENDERED, this._recaptchaRendered);
  }

  componentDidUpdate(){
    // TODO :: Maybe we can bring this up a level?
    Fraction.Helpers.bindLinks();
  }

  loadRecaptchaScript() {
    Fraction.Helpers.loadRecaptchaScript();
    Fraction.Helpers.addLoader("#signin-form");
  }

  // We need to remove the recaptcha element and restart recaptcha in order to change the language
  _localeChanged() {
    if (this.state.captcha) {
      this.setState({
        captcha: false
      }, this._startRecaptcha);
    }
  }

  _startRecaptcha() {
    this.setState({
      captcha: true
    }, this.loadRecaptchaScript);
  }

  _recaptchaRendered() {
    setTimeout(function(){
      Fraction.Helpers.removeLoader("#signin-form");
    }, 1200);
  }

  _checkSigninSubmit(e){
    var email = $("#email-field").val();
    if (!this.props.isValidEmail(email) && this.state.password.length >= 4){
      e.preventDefault();
      this._throwSigninError();
      return false;
    }

    // http://stackoverflow.com/questions/31017261/require-user-to-click-googles-new-recaptcha-before-form-submission
    if (this.state.captcha) {
      var recaptcha = $("#g-recaptcha-response").val();
      if(recaptcha === ""){
          e.preventDefault();
          this.setState({recaptchaError: true});
          return false;
      }
    }

    return true;
  }

  _throwSigninError(){
    this.setState({error: true});
  }

  getError(e){
    if(this.state.error){
      return i18n.t("signin.failure");
    }
  }

  _clickResetPassword(e){
    e.preventDefault();
    Fraction.Router.setRoute('user/forgot', false);
  }

  _cleverLogin(e) {
    e.preventDefault();
    // Redirect to clever URL, which should talk to BC and redirect back
    Fraction.Helpers.Locations.safeRedirect(Fraction.Brand.Clever.url, "_self");
  }

  _onEmailChange(e){
    this.setState({email: e.currentTarget.value});
    if ((!this.state.captcha) &&
        (/vpg|ingram|vitalsource|vitalbook|lightning/i.test(e.currentTarget.value))) {
      this._startRecaptcha();
    }
  }

  _onPasswordChange(e){
    this.setState({password: e.currentTarget.value});
  }

  render(){
    var redirect = document.location.protocol+"//"+document.location.host+document.location.search;
    if (redirect[redirect.length-1]==="/"){
      redirect.substring(0, redirect.length-1);
    }

    var failure = document.location.protocol+"//"+document.location.host+document.location.search+"/#/user/signin/failure/"+encodeURIComponent(this.state.email);
    var error = document.location.protocol+"//"+document.location.host+document.location.search+"/#/system-error/503";
    if (Fraction.redirectAfterSignIn){
      redirect+="/#/"+Fraction.Helpers.redirectUrl();
    }

    if (this.props.captcha){
      redirect = Fraction.Helpers.removeParameter(redirect, "captcha");
      failure = Fraction.Helpers.removeParameter(failure, "captcha");
      error = Fraction.Helpers.removeParameter(error, "captcha");
    }

    var loginFailure = this.props.status==="failure" || this.state.status==="failure";

    return (
      <div>
        <div onScroll={this.props.redraw}>
          { Fraction.Helpers.modalToShow }

          <div className="account">

            {this.props.renderAccountGraphic()}

            <div className="account-content signin">
              <h1>
                {window.toHTML(i18n.t('signin.signin-welcome'))}
              </h1>
              {Fraction.Brand.Clever && Fraction.Brand.Clever.visible &&
                <form onSubmit={this._cleverLogin}>
                  <button className="clever-button" type="submit"><img src="brands/assets/clever.png"></img><span>{i18n.t('signin.clever')}</span></button>
                </form>
              }
              {Fraction.Brand.Signin.instructions &&
                <div className="signin-instructions">{window.toHTML(Fraction.Brand.Signin.instructions)}</div>
              }
              {Fraction.Brand.Signin.enabled &&
                <form onSubmit={this._checkSigninSubmit} id="signin-form" method="post" action={(Fraction.Environment.sslSignin ? "https:" : "")+(Fraction.Brand.jigsawHost ? `//${Fraction.Brand.jigsawHost}/` : Fraction.Environment.jigsawRootURL)+"login"} noValidate>
                  <VstInput required
                            id="email-field"
                            failure={this.getError()}
                            options="large"
                            type="email"
                            name="user[email]"
                            onBlur={this._checkSigninForm}
                            placeholder={i18n.t('base.email')}
                            label={i18n.t('base.email')}
                            value={this.state.email}
                            onChange={this._onEmailChange} />
                  <VstInput required
                            id="password-field"
                            failure={this.getError()}
                            options="large"
                            type="password"
                            name="user[password]"
                            placeholder={i18n.t('base.password')}
                            label={i18n.t('base.password')}
                            onChange={this._onPasswordChange}
                            value={this.state.password} />
                  {this.state.captcha && <div className="g-recaptcha" id="g-recaptcha" data-expired-callback="recaptchaExpiredCallback" data-error-callback="recaptchaErrorCallback"></div>}
                  {this.state.recaptchaError && <span role="alert" className="recaptcha-error">{i18n.t('signin.recaptcha')}</span>}
                  <input type="hidden" name="return" id="login-return" value={redirect} />
                  <input type="hidden" name="failure" id="login-return" ref={this.loginFailureRef} value={failure} />
                  <input type="hidden" name="error" id="login-return-error" ref={this.loginErrorRef} value={error} />
                  <input type="hidden" name="jigsaw_brand" id="jigsaw-brand" value={Fraction.Brand.jigsawBrand} />
                  <VstInput type="submit" label={i18n.t('signin.signin-button')} id="submit-btn" options="block" value={i18n.t('signin.signin-button')} />
                </form>
              }

              <div className="subheading">
                {Fraction.Brand.ForgotPassword.enabled && <a className="forgot-password" onClick={this._clickResetPassword} href="#">{i18n.t('signin.forgot-password')}</a>}
                {!Fraction.Brand.AccountCompletion.ssoOnly &&
                  window.toHTML(i18n.t('signin.signin-create', {url: "/#/user/registration"}))}
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

}

module.exports = SigninContainer;
